<template>
    <div class="agreement-container">
        <div class="pc-contentBox">
            <el-card v-loading="loading" shadow="always" :body-style="{ padding: '20px' }">
                <div class="agreement-title">《{{ agreement.title }}》</div>
                <div class="agreement-content" v-html="agreement.content"></div>
            </el-card>
        </div>
    </div>
</template>

<script>
	import {
		agreementAPI
	} from "@/api/submit.js"
export default {
    data() {
        return {
            loading: false,
            agreement: {}
        }
    },
    mounted() {
        let { key } = this.$route.query
        this.getAgreement(key)
    },
    methods: {
        getAgreement(val) {
            this.loading = true
			agreementAPI(val).then(res => {
                console.log(res);
                this.agreement = res.data
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .agreement-container {
        padding-top: 10px;;
        .agreement-title {
            font-weight: bold;
            font-size: 20px;
            text-align: center;
        }
        .bottom-back {
            width: 100%;
            text-align: center;
            margin-top: 60px;
        }
    }
</style>
